import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { debug, hasErrors } from "../../utils";
import * as validationService from "../../devices/add-device-modal/validationService";
import { DomainNameCardInput } from "./DomainNameCardInput";
import { CardTypes, domainNameCardService } from "./domainNameCardService";
//import { getDomainById } from "./domainManagementService";
import { Spinner } from "../../view/Spinner";


function DomainNameCard({ errors, handleClose, cardType = CardTypes.CREATE, domainId, domain }) {

    const valid = !hasErrors(errors);
    const isCreateMode = cardType === CardTypes.CREATE;
    const formId = "oct-settings-domain-form";

    const [loading, setLoading] = useState(true);
    const [name, setName] = useState("");
    const [kdc, setKDC] = useState("");


    const pDomainNameCardService = new domainNameCardService(cardType, handleClose);

    const fetchData = async () => {
        try {
            if (domainId && cardType === CardTypes.EDIT) {
                //const domain = await getDomainById(domainId);
                if (domain) {
                    setName(domain.name);
                    setKDC(domain.kdc);

                }
            } else {
                validationService.validateNotEmpty(name, 'name');
                validationService.validateNotEmpty(kdc, 'kdc');
            }

            setLoading(false);
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
        }
    };

    useEffect(() => {    
        fetchData();

        return () => {
            validationService.cleanState();
        };
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);


    const onNameChange = (value) => {
        validationService.validateNotEmpty(value, 'name');
        setName(value);
    }

    const onKDCChange = (value) => {
        validationService.validateNotEmpty(value, 'kdc');
        setKDC(value);
    }

    const onSubmit = async (event) => {
        event.preventDefault();

        if (!valid) {
            return;
        }

        if (isCreateMode) {
            await pDomainNameCardService.onCreate({
                name,
                kdc,
                id: domainId,
            });
            return;
        }

        await pDomainNameCardService.onSave({
            name,
            kdc,
            id: domainId,
        });
    }

    return (
        <>
            <div className="modal-body modal-v2-body oct_settings-modal-body">
                {loading ? (
                    <div className="oct_settings-modal-loading">
                        <Spinner />
                    </div>
                ) : (
                    <form id={formId} className="oct_settings-modal-form modal-v2-form" autoComplete="off" onSubmit={onSubmit}>
                        <div className="oct_settings-modal-form-grid">
                            <DomainNameCardInput
                                label={'Name'}
                                value={name}
                                onChange={onNameChange}
                                valid={name}
                                required
                            />

                        <DomainNameCardInput
                            label={'KDC'}
                            value={kdc}
                            onChange={onKDCChange}
                            valid={kdc}
                            required
                        />
                    </div>
                    </form>
                )}
            </div>

            <div className="modal-footer modal-v2-footer oct_settings-modal-footer">
                <div className="modal-v2-footer-note">
                    <span className="modal-v2-footer-note-star">*</span> Required fields
                </div>
                <div className="modal-v2-footer-actions oct_settings-modal-actions">
                    <button type="button" className="btn modal-v2-btn modal-v2-btn-outline oct_settings-modal-btn" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        type="submit"
                        form={formId}
                        className="btn modal-v2-btn modal-v2-btn-primary oct_settings-modal-btn"
                        disabled={loading || !valid}
                    >
                        {isCreateMode ? "Create" : "Save"}
                    </button>
                </div>
            </div>
        </>
    )
}

function mapStateToProps(state) {
    debug("DomainManagementCard mapStateToProps:", state);
    const validation = state.validation;
    return {
        errors: validation || {},
    }
}

export default connect(mapStateToProps)(DomainNameCard);
